import { render, staticRenderFns } from "./PaisWrapper.vue?vue&type=template&id=0c1da51f&scoped=true&"
import script from "./PaisWrapper.vue?vue&type=script&lang=js&"
export * from "./PaisWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PaisWrapper.vue?vue&type=style&index=0&id=0c1da51f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1da51f",
  null
  
)

export default component.exports